/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Users_LinkInputs */

const cs_sreality_users_link = /** @type {(inputs: Sreality_Users_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Správa makléřů`)
};

const en_sreality_users_link = /** @type {(inputs: Sreality_Users_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage brokers`)
};

/**
* | output |
* | --- |
* | "Manage brokers" |
*
* @param {Sreality_Users_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_users_link = /** @type {((inputs?: Sreality_Users_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Users_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_users_link(inputs)
	return cs_sreality_users_link(inputs)
});